import React from 'react'
import { Modal } from 'antd'
import StatusView from '../../StatusView/StatusView'
import './GenerationStatusModal.scss'

/**
 * A reusable modal for showing video generation status (loading, error)
 * with a consistent, premium UI/UX.
 */
const GenerationStatusModal = ({
  visible,
  status = 'loading', // 'loading' | 'error'
  title,
  subTitle,
  error,
  onRetry,
  onClose,
  small,
  zIndex = 1000
}) => {
  return (
    <Modal
      centered
      visible={visible}
      closable={true}
      onCancel={onClose}
      footer={null}
      width={440}
      className={`generation-status-modal ${status}-state-active`}
      zIndex={zIndex}
      maskClosable={false}
      transitionName="zoom"
      maskStyle={{
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(0,0,0,0.45)'
      }}
    >
      <StatusView
        status={status}
        title={title}
        subTitle={subTitle}
        error={error}
        onRetry={onRetry}
        onClose={onClose}
        small={small}
      />
    </Modal>
  )
}

export default GenerationStatusModal
